// extracted by mini-css-extract-plugin
export default {"form":"Setup_form__xEz+w","sectionHeading":"Setup_sectionHeading__2edvd","player":"Setup_player__vJA04","input":"Setup_input__mH7cQ"};